export async function checkAuthStatus() {
    try {
        const response = await fetch("/api/_allauth/browser/v1/auth/session", {
            method: "GET",
            credentials: "include",
        });

        if (response.status === 200) {
            const data = await response.json();
            let user = {
                isAuthenticated: data.meta.is_authenticated,
                user: data.data.user,
                // Expose name/email at top level for easy access
                name: data.data.user.display || data.data.user.username || "",
                email: data.data.user.email || "",
            };

            // Try to fetch user profile to get the first_name from user-profile/current
            if (user.isAuthenticated) {
                try {
                    const profileRes = await fetch("/api/v1/user-profile/current", {
                        method: "GET",
                        credentials: "include",
                    });
                    if (profileRes.status === 200) {
                        const profileData = await profileRes.json();
                        console.log("profile data:", profileData);
                        if (profileData.first_name || profileData.name) {
                            user.name = profileData.first_name || profileData.name || user.name;
                            user.user.first_name = profileData.first_name || profileData.name;
                        }
                    }
                } catch (err) {
                    console.error("Error fetching user profile:", err);
                }
            }
            // Fetch stats if authenticated
            if (user.isAuthenticated) {
                try {
                    const statsRes = await fetch("/api/v1/student/stats/", {
                        method: "GET",
                        credentials: "include",
                    });
                    if (statsRes.status === 200) {
                        const statsData = await statsRes.json();
                        console.log("Student stats:", statsData);
                        user.stats = statsData;
                    } else {
                        user.stats = null;
                    }
                } catch (err) {
                    console.error("Error fetching student stats:", err);
                    user.stats = null;
                }
                // Fetch video lessons endpoints
                try {
                    const allRes = await fetch("/api/v1/student/video-lessons/all/", {
                        method: "GET",
                        credentials: "include",
                    });
                    user.videoLessonsAll = allRes.status === 200 ? await allRes.json() : [];
                    console.log("videoLessonsAll:", user.videoLessonsAll);
                } catch (err) {
                    console.error("Error fetching videoLessonsAll:", err);
                    user.videoLessonsAll = [];
                }
                try {
                    const completedRes = await fetch("/api/v1/student/video-lessons/completed/", {
                        method: "GET",
                        credentials: "include",
                    });
                    user.videoLessonsCompleted = completedRes.status === 200 ? await completedRes.json() : [];
                    console.log("videoLessonsCompleted:", user.videoLessonsCompleted);
                } catch (err) {
                    console.error("Error fetching videoLessonsCompleted:", err);
                    user.videoLessonsCompleted = [];
                }
                try {
                    const startedRes = await fetch("/api/v1/student/video-lessons/started/", {
                        method: "GET",
                        credentials: "include",
                    });
                    user.videoLessonsStarted = startedRes.status === 200 ? await startedRes.json() : [];
                    console.log("videoLessonsStarted:", user.videoLessonsStarted);
                } catch (err) {
                    console.error("Error fetching videoLessonsStarted:", err);
                    user.videoLessonsStarted = [];
                }
                // Fetch subscription status
                try {
                    const subRes = await fetch("/api/billing/subscription/status/", {
                        method: "GET",
                        credentials: "include",
                    });
                    if (subRes.status === 200) {
                        let subData = await subRes.json();
                        console.log("Subscription status raw:", subData);
                        // Handle if response is wrapped in data key or is an array
                        if (subData.data) subData = subData.data;
                        if (Array.isArray(subData))
                            subData =
                                subData.find((s) => Number(s.status) === 2 || s.status === "active") ||
                                subData[0] ||
                                {};

                        user.subscription = subData;
                        // Populate stats for backward compat with profile page
                        if (!user.stats) user.stats = {};
                        const isActive =
                            subData.status === "active" ||
                            subData.status === "trialing" ||
                            Number(subData.status) === 2;
                        if (isActive) {
                            user.stats.subscription_remaining_days =
                                subData.remaining_days ||
                                subData.days_remaining ||
                                subData.days_left ||
                                subData.trial_days_remaining ||
                                30;
                            user.stats.subscription_status = "active";
                            user.stats.subscription_plan =
                                subData.plan || subData.plan_name || subData.tariff_name || "";
                        } else {
                            user.stats.subscription_remaining_days = 0;
                            user.stats.subscription_status = subData.status || "inactive";
                        }
                    } else {
                        user.subscription = null;
                    }
                } catch (err) {
                    console.error("Error fetching subscription status:", err);
                    user.subscription = null;
                }
            }
            return user;
        }

        if (response.status === 401 || response.status === 410) {
            return { isAuthenticated: false };
        }
    } catch (error) {
        console.error("Помилка при перевірці стану авторизації:", error);
        return { isAuthenticated: false };
    }
}
